import { render, staticRenderFns } from "./BatchCountryTable.vue?vue&type=template&id=2640f7f0&scoped=true&"
import script from "./BatchCountryTable.vue?vue&type=script&lang=js&"
export * from "./BatchCountryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640f7f0",
  null
  
)

export default component.exports